import UserPermissionSelect from './UserPermissionSelect';

export default UserPermissionSelect;
